//@ts-nocheck
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/forms/jha-form-textarea-input/jha-form-textarea-input";
@customElement("masked-input-field")
export class MaskedInputField extends LitElement {
  constructor() {
    super();
  }
  @property({ type: String }) value = "";
  @property({ type: String }) maskChar = "*";
  @property() required = null;
  @property({ type: String }) placeholder = "";
  @property() showWarning = null;
  @property({ type: String }) warning = "";
  @property({ type: String }) label = "";
  @property({ type: String }) dataId = "";
  _handleInput(event) {
    const inputValue = event.target.value;
    this.value = inputValue;
    this.dispatchEvent(
      new CustomEvent("secretValuechanged", { detail: this.value })
    );
  }
  render() {
    const maskedValue = this.value?.replace(/./g, this.maskChar);
    return html`
    <jha-form-textarea-input
    .required=${this.required}
    .placeholder=${this.placeholder}
    ?showWarning=${this.showWarning}
    .warning=${this.warning}
    type="textarea"
    role="textbox"
    .label=${this.label}
    .data-id=${this.dataId}
    .data-auto-id=${this.dataAutoId}
    .value=${maskedValue}
    @change=${this._handleInput}
    outline                          
></jha-form-textarea-input>
    `;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "masked-input-field": MaskedInputField;
  }
}
